import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="pt-16 pb-4 px-4 md:px-8" data-id="element-128">
      <div className="max-w-7xl mx-auto" data-id="element-129">
        <div className="grid md:grid-cols-2 gap-4 items-center" data-id="element-130">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-131">
            <h1 className="text-3xl md:text-5xl font-bold text-[#1A1A1A] mb-3 leading-tight" data-id="element-132">
              Mamá, Cuéntame Tu Historia
            </h1>
            <p className="text-base md:text-lg text-gray-700 mb-3 leading-relaxed" data-id="element-133">
              Un libro guiado para que mamá escriba su vida con sus propias
              palabras. Un legado que tus hijos y nietos atesorarán para
              siempre.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex flex-col items-center" data-id="element-134">
            <img src="https://cdn.magicpatterns.com/uploads/sPg9c1ZySptSSTSQ6tMgw7/Fondo_hogareno_femenino_202605041212.jpg" alt="Mamá, Cuéntame Tu Historia" className="w-full max-w-[220px] rounded-lg shadow-2xl" data-id="element-135" />
            <p className="mt-2 text-center italic text-sm md:text-base leading-snug max-w-xs text-[#050505]" data-id="element-136">
              Porque cada mamá tiene una historia que merece ser contada,
              recordada y guardada para siempre. 🤍
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}